export default __webpack_public_path__ + "1ecbc822db6b66fd2e4f66ce2fd7bc61.svg";